import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { ConfirmDialogResponse, VirkeskopAffarsformer } from "~app/common/models/constants";
import { SearchAvtalByAnvandareRequestDTO } from "~app/common/models/virkeskop/v2/SearchAvtalByAnvandareRequestDTO";
import { KONTRAKTSTATUSAR, VACS_KONTRAKTSTATUSAR } from "~app/features/virkeskop/models/kontrakt-detail-model";
import { RaskCommonModule } from "../../../../../../common/rask-common.module";
import { SystemadministrationService } from "../../../systemadministration.service";
import { MoveAvtal } from "../virkeskontrakt.model";

@Component({
    selector: "rask-sysadm-move-avtal",
    templateUrl: "./sysadm-move-avtal.component.html",
    styleUrl: "./sysadm-move-avtal.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RaskCommonModule]
})
export class SysadmMoveAvtalComponent implements OnInit {
    protected affarsformer: SelectionItem[] = VirkeskopAffarsformer.AllaWithShortType.map(({ key, value }) => ({
        text: `${key}`,
        value
    }));
    protected avtalList: MoveAvtal[];
    protected form: UntypedFormGroup;
    protected isAllChecked: boolean;
    protected kontraktstatusar: SelectionItem[] = KONTRAKTSTATUSAR.map((value) => ({
        text: value,
        value
    }));
    protected vacsKontraktstatusar: SelectionItem[] = VACS_KONTRAKTSTATUSAR.map(({ status, statusCode }) => ({
        text: status,
        value: statusCode
    }));

    private readonly adminService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);
    private readonly raskModalService = inject(RaskModalService);

    ngOnInit(): void {
        this.clearAll();
    }

    protected checkAll($event): void {
        this.avtalList.forEach(a => {
            a.selected = $event;
        });
    }

    protected clearAll(): void {
        this.clearResults();
        this.form = new UntypedFormGroup(
            {
                fromUserSearch: new UntypedFormControl(""),
                toUserSearch: new UntypedFormControl(""),
                kontraktstatus: new UntypedFormControl([]),
                affarsform: new UntypedFormControl([]),
                vacsStatus: new UntypedFormControl([])

            });
    }

    protected clearResults(): void {
        this.avtalList = [];
    }

    protected getSelectedCount(): number {
        return this.avtalList?.filter(x => x.selected === true).length ?? 0;
    }

    protected getVacsStatusText(vacsCode: number): string {
        const statusText = VACS_KONTRAKTSTATUSAR.find(x => x.statusCode === vacsCode)?.status;
        if (!statusText) {
            return "Saknas";
        }
        return statusText;
    }

    protected hasMoveData(): boolean {
        return this.form.get("fromUserSearch")?.value &&
            this.form.get("toUserSearch")?.value &&
            this.getSelectedCount() > 0;
    }

    protected hasSearchData(): boolean {
        return this.form.get("fromUserSearch")?.value;
    }

    protected moveSelectedContracts(): void {
        const moveContractIds = this.avtalList.filter(c => c.selected === true).map(c => c.avtal.id);

        this.raskModalService.confirm(new ModalSettings("Flytta avtal", `Är du säker på att du vill flytta ${moveContractIds?.length} avtal?`))
            .subscribe(dialogResult => {
                if (dialogResult === ConfirmDialogResponse.save) {
                    this.adminService.moveAvtal(this.form.get("fromUserSearch").value, this.form.get("toUserSearch").value, moveContractIds).subscribe(result => {
                        this.avtalList = this.avtalList.filter(x => !x.selected);
                    });
                }
            });
    }

    protected searchAnvandareTypeahead = (searchString: string) => this.adminService.searchAnvandare(searchString);

    protected searchAvtal(): void {
        this.clearResults();
        const searchRequest = new SearchAvtalByAnvandareRequestDTO();
        searchRequest.anvandareId = this.form.get("fromUserSearch").value;
        searchRequest.affarsform = this.form.get("affarsform").value;
        searchRequest.kontraktstatus = this.form.get("kontraktstatus").value;
        searchRequest.vacsStatus = this.form.get("vacsStatus").value;

        this.busyService.addWork(this.adminService.searchAvtal(searchRequest))
            .subscribe(result => {
                this.avtalList = result.map(c => new MoveAvtal(c, true));
                this.isAllChecked = true;
            });
    }

    protected selectedChanged($event): void {
        this.isAllChecked = !this.avtalList.some(a => a.selected === false);
    }
}
